import React from 'react'
import BlockingTable from './BlockingTable'
import { useSelector } from 'react-redux'
import RoomBlockingList from '../../../Hotels/Components/RoomBlocking/RoomBlockingList'

const BlockingList = () => {
  const { user, userType } = useSelector((state) => state.auth);
  const adminUser = user?.user || {};
  const adminLevelId = Number(adminUser.LevelId ?? adminUser.LevelID ?? adminUser.levelId ?? 0);
  const hasHotelScope = adminUser.PropertyID !== null && adminUser.PropertyID !== undefined;
  const isLevelOneAdmin =
    adminLevelId === 1 ||
    Number(adminUser.customerId) === 1 ||
    adminUser.UserName?.toString().toLowerCase() === "admin";
  const roleValues = [
    adminUser.Role,
    adminUser.role,
    adminUser.roleName,
    adminUser.user_role,
    adminUser.designation,
    adminUser.Designation,
    adminUser.vchDesignation,
    ...(Array.isArray(adminUser.roles) ? adminUser.roles : []),
  ];
  const isHotelManager =
    userType === "admin" &&
    !isLevelOneAdmin &&
    (hasHotelScope ||
      roleValues.some((role) =>
        String(role || "").toLowerCase().includes("manager"),
      ));

  if (isHotelManager) {
    return <RoomBlockingList />;
  }

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
        <div className="row g-3">
            <div className="col-sm-12">
                <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <h3 className="fw-bold mb-0">Blocked Rooms List</h3>
                </div>
            </div>
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-body">
                        <BlockingTable/>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default BlockingList
